export const initialState = {
    auditTrailData: [],
    auditTrailCount: 0,
    auditTrailLoading: false,
  };
  